export function isTaskActivityDone(activityProgress) {
  return (
    activityProgress?.progressSlots &&
    activityProgress.progressSlots.length &&
    activityProgress.progressSlots.length == activityProgress.repetitions &&
    activityProgress.progressSlots.every((slot) => slot.progress == 100)
  );
}
